import React from 'react'
import { Layout } from './Layout'
import { useProps } from './useProps'

export const SurveySchedulesTable = (params: { survey: App.Survey }) => {
  return <Layout {...useProps(params)} />
}
